export default __webpack_public_path__ + "static/media/jenkins.6372ba9b.svg";